import { render, staticRenderFns } from "./RowGroupPermission.vue?vue&type=template&id=65ac9d12"
import script from "./RowGroupPermission.vue?vue&type=script&lang=js"
export * from "./RowGroupPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports